module.exports = __webpack_public_path__ + "images/flag-finland_9c8b9951250e00b0d88860d1e83118f0.svg";